@if (!incident) {
    <div fxLayout="column" fxLayoutAlign="start start" class="w-100 bc-mono-white radius-16 p-24">
        <div class="t2-semi-bold">{{ 'i18n_af_incidentAmountInformation' | translate }}</div>
        <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
    </div>
}

@if (incident) {
    <mat-expansion-panel
        [hideToggle]="Spinner.isShown('initForms')"
        [disabled]="Spinner.isShown('initForms')">
        <mat-expansion-panel-header class="w-100"
                                    [class.loading]="Spinner.isShown('initForms')"
                                    fxLayout="start space-between">
            <mat-panel-title class="no-wrap t2-semi-bold">
                {{ 'i18n_af_incidentAmountInformation' | translate }}
            </mat-panel-title>
            @if (Spinner.isShown('initForms')) {
                <mat-panel-description fxLayoutAlign="end">
                    <ui-kit-spinner [diameter]="16" [strokeWidth]="3" spinnerIds="initForms"/>
                </mat-panel-description>
            }
        </mat-expansion-panel-header>
        <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
    </mat-expansion-panel>
}

<ng-template #formTemplate>
    @if (form) {
        <form [fxHide]="Spinner.isShown('initForms')" [formGroup]="form" fxLayout="column" fxLayoutAlign="start start" class="w-824"
              (submit)="submit()">
            <div class="grid-form-container">
                @for (field of fields; track field) {
                    @if (getControl(field + 'Amount')) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                            <div
                                class="t5 c-primary-gray-600">{{ ('i18n_af_label#' + field + 'Amount') | translate }} {{ getControl(field + 'Amount').hasValidator(Validators.required) ? '*' : '' }}
                            </div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.enabled && getControl(field+'Amount').value">
                                <input matInput
                                       commonsTiynTengeInput
                                       [formControl]="getControl(field+'Amount')"
                                       [placeholder]="('i18n_af_placeholder#' + field + 'Amount' ) | translate"
                                       [name]="field+'Amount'"/>
                                @if (getControl(field + 'Amount').hasError('required')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    <af-dictionary-selector dictionaryName="currency"
                                            [control]="getControl(field+'AmountCurrency')"
                                            [predefinedValue]="getCurrencyValue(field)"
                                            label="i18n_af_labelCurrency"
                                            placeholder="i18n_af_placeholderCurrency"/>
                }
            </div>
            <div fxLayout="column" fxLayoutAlign="start start" class="w-100 mt-24">
                <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelLossTotalAmount' | translate }}*</div>
                <mat-form-field class="w-100 mt-4">
                    <input matInput
                           commonsTiynTengeInput
                           formControlName="lossTotalAmount"
                           [placeholder]="('i18n_af_placeholderLossTotalAmount' ) | translate"
                           name="lossTotalAmount"/>
                </mat-form-field>
            </div>
            @if (!incident) {
                <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-40 w-100">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <ui-kit-button spinnerId="submit"
                                       [label]="'i18n_af_buttonNext' | translate"/>
                        <ui-kit-button class="ml-16"
                                       color="accent"
                                       buttonType="button"
                                       type="text"
                                       (clickListener)="cancel.emit()"
                                       [label]="'i18n_af_buttonCancel' | translate"/>
                    </div>
                    <ui-kit-button type="secondary"
                                   (clickListener)="skipStep()"
                                   [label]="'i18n_af_buttonSkip' | translate"/>
                </div>
            }
        </form>
    }
</ng-template>
